<app-main-layout>
  <section class="flex flex-col gap-3">
    <app-card>
      <app-card-header
        title="Verfügbare Check-Ins"
        subTitle="heute"
        [iconPath]="'assets/icons/scan.svg'"
        [showLoadingSpinner]="requestState() === RequestStateEnum.PENDING"
      />

      <section class="flex flex-col gap-2">
        @if (activities().length === 0) {
          <app-no-entries-placeholder text="Keine Check-Ins verfügbar" />
        }

        @for (activity of activities(); track activity.id) {
          <app-check-in-item [activity]="activity">
            <div class="flex flex-col gap-2">
              <app-button
                text="QR-Code anzeigen"
                [fullWidth]="true"
                (clicked)="showQrCodeModal(activity)"
              />

              <app-button
                text="Manueller Check-In"
                variant="secondary"
                [fullWidth]="true"
                (clicked)="showManualCheckInModal(activity)"
              />

              <app-button
                text="Teilnehmer anzeigen"
                variant="secondary"
                [fullWidth]="true"
                (clicked)="showCheckedInUsersModal(activity)"
              />
            </div>
          </app-check-in-item>
        }
      </section>
    </app-card>
  </section>
</app-main-layout>
